import React from 'react';

const SimpleTasksHeader = () => {
	return (
		<div className="simple-tasks-header">
			<h1 id="tasks">Simple Tasks</h1>
			<p>Now that we have covered the basics, here are some basic use cases to help you get going.</p>
		</div>
	);
};

export default SimpleTasksHeader;


// WEBPACK FOOTER //
// ./src/components/getting-started/SimpleTasksHeader.js